import PageContext from "../Context/PageContext";
import { useContext, useEffect, useState } from "react";

import uniqid from 'uniqid';

import { initShapeSection } from '../ElementConf/initShapeSection'
import { initCadreSection } from '../ElementConf/initCadreSection'
import ImageSection from "./ImageSection";
import ElevationSection from "./ElevationSection";
import TextSection from "./TextSection";
import Helper from "../Component/Helper";
import { createAddElementAction } from "../history/element.history";

export default function ShapeSection() {

    //const {} = useContext(PageContext);

    const [whichSubSectionOpen, setWhichSubSectionOpen] = useState("main");
    const [imageSections, setImageSections] = useState<any[]>([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_PUBLIC_URL + "/images/manifest-img.json")
            .then(res => res.json()) // parsing ici
            .then(data => {
                setImageSections(data); // alimentation du composant
            })
            .catch(err => console.error(err));
    }, []);

    const listShapeSection = initShapeSection.map((shapeSection: any) =>
        <ShapeSectionImage shape={shapeSection} key={shapeSection.id} />
    );

    const listImageSection = imageSections.map((imageSection: any) =>
        <LogoSectionImage image={imageSection} key={imageSection.id} />
    );

    const listCadreSection = initCadreSection.map((cadreSection: any) =>
        <CadreSectionImage image={cadreSection} key={cadreSection.id} isFull={false} />
    );

    const listCadreSectionFull = initCadreSection.map((cadreSection: any) =>
        <CadreSectionImage image={cadreSection} key={cadreSection.id} isFull={true} />
    );

    return (
        <div>
            {whichSubSectionOpen === 'main' && <div>

                <h2>Ajoutez des éléments</h2>
                <div className="texte-abs-section">Rendez votre affiche vraiment unique...</div>

                <h3>Ajoutez du texte</h3>
                <TextSection></TextSection>

                <div className="subtitle-section">
                    <h3 >Ajoutez des images</h3>
                    <Helper text="Apporte ta touche personnelle à ton affiche en intégrant les images incontournables de ton aventure. Cependant, veille à utiliser des images de qualité, car une image de basse qualité pourrait apparaître floue ou pixelisée sur ton affiche​" />
                </div>
                <ImageSection setWhichSubSectionOpen={setWhichSubSectionOpen} whichSubSectionOpen={whichSubSectionOpen}></ImageSection>

                <div className="list-image-section">
                    <ElevationSection />
                </div>

                <div className="">
                    <div className="tout-afficher-shape-section">
                        <div><h3> Formes </h3></div>
                        <div className="tout-afficher-container"><div className="tout-afficher-title" onClick={() => setWhichSubSectionOpen('formes')} style={{ cursor: 'pointer' }}> Tout Afficher </div></div>
                    </div>
                </div>
                <div className="list-image-section">
                    {listShapeSection}
                </div>
                <div className="">
                    <div className="tout-afficher-shape-section">
                        <div><h3> Logos </h3></div>
                        <div className="tout-afficher-container"><div className="tout-afficher-title" onClick={() => setWhichSubSectionOpen('logos')} style={{ cursor: 'pointer' }}> Tout Afficher </div></div>
                    </div>
                </div>
                <div className="list-image-section">
                    {listImageSection}
                </div>
                {/**/}<div className="">
                    <div className="tout-afficher-cadre-section">
                        <div><h3> Cadres </h3></div>
                        <div className="tout-afficher-container"><div className="tout-afficher-title" onClick={() => setWhichSubSectionOpen('cadres')} style={{ cursor: 'pointer' }}> Tout Afficher </div></div>
                    </div>
                </div>
                <div className="list-image-section">
                    {listCadreSection}
                </div>


            </div>}

            {whichSubSectionOpen === 'formes' && <div>
                <div className="btn-back-container">
                    <button className="main-button2" onClick={() => setWhichSubSectionOpen('main')} >
                        Retour
                    </button>
                </div>
                <div className="list-image-section-full">
                    {listShapeSection}
                </div>
            </div>}
            {whichSubSectionOpen === 'logos' && <div>
                <div className="btn-back-container">
                    <button className="main-button2" onClick={() => setWhichSubSectionOpen('main')} >
                        Retour
                    </button>
                </div>
                <div className="list-image-section-full">
                    {listImageSection}
                </div>
            </div>}
            {whichSubSectionOpen === 'mesimages' && <div>
                <div className="btn-back-container">
                    <button className="main-button2" onClick={() => setWhichSubSectionOpen('main')} >
                        Retour
                    </button>
                </div>
                <ImageSection setWhichSubSectionOpen={setWhichSubSectionOpen} whichSubSectionOpen={whichSubSectionOpen}></ImageSection>
            </div>}
            {whichSubSectionOpen === 'cadres' && <div>
                <div className="btn-back-container">
                    <button className="main-button2" onClick={() => setWhichSubSectionOpen('main')} >
                        Retour
                    </button>
                </div>
                <div className="list-cadre-section-full">
                    {listCadreSectionFull}
                </div>
            </div>}
        </div>
    );
}

const ShapeSectionImage = (props: any) => {

    const shapeElem = props.shape;

    const { objItems, addItem, history, removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, setObjItems } = useContext(PageContext);

    function addShape(json: any) {
        /* Should be clone for working with different obj */
        let copyJson = { ...json };
        copyJson.id = uniqid();
        let copyJsonStyle = { ...json.style };
        copyJson.style = copyJsonStyle;

        if (addItem != null) {
            addItem(copyJson);
            //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
            const action = createAddElementAction(copyJson, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
            history.add(action);
        }
    }

    return (
        <div className='shape-section-elem' onClick={() => addShape(shapeElem)}>
            <img src={process.env.REACT_APP_PUBLIC_URL + shapeElem.src} alt="Ajouter" />
        </div>
    )
}

const LogoSectionImage = (props: any) => {

    const imgElem = props.image;

    const { objItems, addItem, history, removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, setObjItems } = useContext(PageContext);

    function addImage(json: any) {
        /* Should be clone for working with different obj */
        let copyJson = { ...json };
        copyJson.id = uniqid();
        let copyJsonStyle = { ...json.style };
        copyJson.style = copyJsonStyle;

        if (addItem != null) {
            addItem(copyJson);
            //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
            const action = createAddElementAction(copyJson, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
            history.add(action);
        }
    }

    return (
        <div className='image-section-elem' onClick={() => addImage(imgElem)}>
            <img src={process.env.REACT_APP_PUBLIC_URL + imgElem.src} alt="Ajouter" />
        </div>
    )
}


/* 
Gestion des cadresèelement
Fichiers concernés :
ShapeSection.tsx -> CadreSectionImage
TextElement.tsx -> handleOverlap

ShapeSection.tsx : Ajout d’un cadre

Lors de l’ajout d’un cadre, on récupère un modèle dans la liste initCadreSection.
Une copie de l’élément est faite afin de garantir un cadre unique.
Les valeurs de transform et translate sont initialisées à 0 pour :
- éviter qu’elles soient null
- prévenir d’éventuelles erreurs dans les calculs ultérieurs (NaN).
Les propriétés sizePX et sizePourcent n’ont pas besoin d’être initialisées.

Insertion d’une image : TextElement.tsx – Fonction handleOverlap

Une image est insérée dans le cadre nouvellement créé.
Vérifie si un élément (image) intersecte avec un cadre.
En cas d’intersection :
- l’image est associée au cadre-element via sa source,

aucun set des valeurs de crop n’est nécessaire (le clip-path gère automatiquement le découpage)
SAUF on ajoute une image dans un cadre-element qui avait déjà une image : dans ce cas, on init crop à 0.

Gestion du crop et du redimensionnement

Les cas générant des actions : 
- Resize cadre-element
- Translate cadre-element
- Resize img à l'intérieur de cadre-element
- Translate img à l'intérieur de cadre-element

Redimensionnement du cadre : updateTransformCropElement

Si le CropCadreImageCard n’a pas été translaté à l’intérieur → aucun calcul effectué (évite divisions inutiles).
Si translateX ou translateY ≠ 0 :
- le translate est multiplié par le coefficient de resize
- la taille reste exprimée en pourcentage, donc pas de mise à jour nécessaire.
- on s’assure que les valeurs calculées soient bien des entiers (évite les NaN déjà rencontrés).

*/

const CadreSectionImage = (props: any) => {

    const imgElem = props.image;
    var isFull = props.isFull;

    const { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems, history } = useContext(PageContext);

    function addCadre(json: any) {
        /* Should be clone for working with different obj */
        let copyJson = { ...json };
        copyJson.id = uniqid();
        let copyJsonStyle = { ...json.style };
        copyJson.style = copyJsonStyle;

        //Il est important d'initialiser transform et translate pour éviter les erreur de calculs sur NaN
        copyJson.cropCadre = {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            transform: "translate(0px, 0px)",
            translate: { x: 0, y: 0 },
            isPushImg: false,
        }

        if (addItem != null) {
            addItem(copyJson);

            //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
            const action = createAddElementAction(copyJson, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
            history.add(action);

        }
    }

    function calcSizeInSection(json: any) {
        var w = typeof json.width === 'string' ? parseFloat(json.width.replace("px", "")) : json.width;
        var h = typeof json.height === 'string' ? parseFloat(json.height.replace("px", "")) : json.height;

        //si égal, peu importe, suffit de set l'un ou l'auter
        if (w >= h) return "w";
        else return "h";
    }

    return (
        <div className={isFull ? 'cadre-section-elem' : 'image-section-elem'} onClick={() => addCadre(imgElem)} style={{
            clipPath: imgElem.style["clip-path"],
            width: (calcSizeInSection(imgElem) === "h" && isFull ? "80px" : ""),
            height: (calcSizeInSection(imgElem) === "w" && isFull ? "80px" : "")
        }}>
            {<img src={process.env.REACT_APP_PUBLIC_URL + imgElem.src} alt="Ajouter" />}
            {/*<img src={"http://localhost:3000/studio" + imgElem.src } alt="Ajouter" />*/}
        </div>
    )
}